/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const calculateComboResponseSchemaSchema = z.object({
	price: z.number(),
	incorrectlyFilledGroups: z.array(z.uuid()).optional(),
});
